import { mapActions, mapState, mapGetters } from 'vuex'
import formButton from '@/components/common/form-button/form-button.vue'
import pagination from '@/components/common/pagination/pagination.vue'
import router from '@/router'

export default {
  components: {
    formButton,
    pagination
  },
  data() {
    return {
      columns: ['id', 'name', 'status', 'edit']
    }
  },
  computed: {
    ...mapGetters('user', ['isSuperAdmin']),
    ...mapState('attributesTypes', ['attributesTypes']),
    options: function () {
      return {
        filterable: false,
        headings: {
          name: 'Name',
          status: 'Status',
          edit: ' '
        },
        perPageValues: [10],
        orderBy: {
          column: 'name'
        },
        requestFunction: this.getAttributesTypesList,
        responseAdapter: function (resp) {
          var data = this.getResponseData(resp)
          return {
            data: data.data,
            count: data.total
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('attributesTypes', ['getAttributesTypesList', 'getAttributeType']),
    editAttribute: async function (id) {
      try {
        await this.getAttributeType({ id })
        router.push({ name: 'attribute-edit' })
      } catch (e) {
        this.$notify({
          text: 'Error while getting attribute',
          type: 'error'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/attributes/attributes-list/attributes-list.js